export default "__VITE_ASSET__DIu1WyPn__"